import { Backdrop, Box, Divider, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { AddressSelector } from '../../../../store/Address'
import { AmericanStatesSelector } from '../../../../store/AmericanStates'
import { WaterSystemCoordinatesSelector } from '../../../../store/publicWaterSystem'
import { UtilityDetailSelector } from '../../../../store/utilityDetails'
import { WaterSystemsActions, WaterSystemsSelector } from '../../../../store/waterSystems'
import { useStyles } from '../../../../theme/styles'
import { handleMapZoomOnZip } from '../../../../utils/mapHelper'
import { CustomButton } from '../../../Button'
import { CloseIcon } from '../../../icons/CloseIcon'
import { Loader } from '../Loader'
import FilterComponent from './components/FilterComponent'
import RadiusComponent from './components/RadiusComponent'
import UtilityCardWidget from './components/UtilityCardWidget'
import { MapRefProps } from '../../../../views'
import { AppActions, AppSelector } from '../../../../store/app'
import ReactPixel                                    from 'react-facebook-pixel'
import ReactGA from 'react-ga4'

interface UtilityDetailProps {
  onClose: (e: React.MouseEvent<Element> | React.KeyboardEvent<Element>) => void
  setPopupPosition?: (position: { x: number; y: number } | null) => void
  setPopupDetails?: (details: any) => void
  setFillColor?: (color: string) => void
  mapRef: React.MutableRefObject<MapRefProps | null>

}

export const UtilityDetail: React.FC<UtilityDetailProps> = ({
  onClose,
  mapRef,

}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const styles = useStyles()

  const americanStates = useSelector(AmericanStatesSelector.getStates)
  const selectedAddress = useSelector(AddressSelector.selectAddress)
  const utilityDetailOpen = useSelector(UtilityDetailSelector.getShowDrawer)
  const utilityOpen = useSelector(AppSelector.getMapDataDrawerState)
  const waterSystemsLoading = useSelector(WaterSystemsSelector.loading)

  const [sortOrder, setSortOrder] = useState('highest')

  const handleSortChange = (value: string) => {
    setSortOrder(value)
  }

  const handleRadiusChange = async (value: number) => {
    try {
      if (!selectedAddress) return

      const resultAction = await dispatch(
        WaterSystemsActions.fetchPublicWaterSystemsByAddressAsync({
          latitude: selectedAddress.latitude,
          longitude: selectedAddress.longitude,
          radius: value,
        }) as any,
      )

      if (WaterSystemsActions.fetchPublicWaterSystemsByAddressAsync.fulfilled.match(resultAction)) {
        handleMapZoomOnZip(resultAction.payload, americanStates, dispatch)
      }

      dispatch(WaterSystemsActions.setUserSearched(true))
    } catch (error) {
      console.error('Error fetching public water systems by address:', error)
    }
  }

  return (


      <Stack sx={{
        height: '100%',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        minWidth: '30vw',

         }}>
        <Backdrop
          open={waterSystemsLoading}

          sx={{
            backgroundColor: 'rgba(0,0,0,0.2)',
            backdropFilter: 'blur(1px)',
            position: 'absolute',
            transition: 'none',
            width: '100%',
            minWidth: '30vw',
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Loader size="large" />
        </Backdrop>

        {/* Fixed Header*/}
        <Stack gap={2} p={3} sx={{ pb: 0, width: '100%' }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" color="text.primary" fontWeight={600}>
              Utilities near you
            </Typography>
            <IconButton onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Stack>
          <Divider />
        </Stack>
         {/*Scrollable Content*/}

        <Box sx={{ flexShrink: 1, mr: 1, overflow: 'auto', ...styles.scrollbar }}>
          <Stack gap={2} p={3}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <FilterComponent onSortChange={handleSortChange} />
              <RadiusComponent onRadiusChange={handleRadiusChange} isLoading={waterSystemsLoading} />
            </Box>
            <UtilityCardWidget
              sortOrder={sortOrder}
              mapRef={mapRef}
            />
          </Stack>
        </Box>


         {/*Fixed Button*/}
        <Box sx={{ pt: 2, p: 2, mt: 'auto' }}>

          <CustomButton fullWidth onClick={() => {
            ReactPixel.trackCustom("click", {id:'test_your_water', name: 'Test Your Water'})
            ReactGA.event({action: 'click', category:'User event tracking', label:'Test your water - Details'})
            navigate('/landing')
          }} text="Test Your Water" />
        </Box>
      </Stack>

  )
}
